import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagDto } from '../../tags/dtos/tag.dto';

/**
 * Create vehicle group DTO
 */
export class CreateVehicleGroupDto {
  uuid!: string;
  name!: string;
  description?: string | null;
  notes?: string | null;
  files?: FileDto[] | null;
  tags?: TagDto[] | null;
}
